export default __webpack_public_path__ + "fd9d8fdcbe8fa8c5621858039eb887c4.svg";